import { render, staticRenderFns } from "./CreateForms.vue?vue&type=template&id=3cb7907a"
import script from "./CreateForms.vue?vue&type=script&lang=js"
export * from "./CreateForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports